export default __webpack_public_path__ + "static/Jamie-Thomson-e7d463567697c1492708728ab9606906.png";